import Component from '../../classes/Component';
import variables from "../../variables";
import {getChoice, getMeta, isElement, resetChoice} from "../../helpers/_utilities";
import {$data} from "../../helpers/data";
import is from "is_js";
import debounce from "lodash.debounce";
import {$dom} from "../../helpers/dom";
import {$events} from "../../helpers/events";
import Choices from "choices.js";

const targetSelectSelector = '.'+variables.classNames.searchSelect;
const searchTargetAttr = 'data-search-target';
const boundSelectIdAttr = 'data-bound-select-id';
const excludeAllCountryOptionAttr = 'data-exclude-all-country-option';

const {
    list: listClassName,
    listDropdown: listDropdownClassName,
    containerOuter: containerClassName,
    input: inputClassName
} = variables.choicesOptions.classNames;

const {searchTypes} = variables;

export default function () {
    const $Page = this;

    return new Component({
        name: 'searchSelect',
        requiredTargets: targetSelectSelector,
        onCreate() {
            this.fields = {};
            this.idWarn = selectEl => console.warn('Please, provide id-attribute to custom city select: ', selectEl);
        },
        onInit() {
            const storage = (settings = {
                action: '',
                params: {},
                results: [],
                searchType: ''
            }) => {
                if (settings?.action !== 'get' && settings?.action !== 'set') return '';
                const prefix = settings.searchType+':';

                switch (settings.action) {
                    case 'get':
                        let result = sessionStorage.getItem(
                            prefix+JSON.stringify(settings.params)
                        )
                        return result ? JSON.parse(result) : null
                    case 'set':
                        sessionStorage.setItem(
                            prefix+JSON.stringify(settings.params),
                            JSON.stringify(settings.results)
                        )
                        break;
                }
            }

            this.updateField = (id, updates) => {
                if (this.fields.hasOwnProperty(id)) {
                    this.fields[id] = {
                        ...this.fields[id],
                        ...updates
                    }
                }

                return this;
            }

            this.getContainer = select => {
                if (select instanceof Choices) {
                    return select.passedElement.element.closest('.'+containerClassName)
                } else if (isElement(select)) {
                    return select.closest('.'+containerClassName)
                }

                return null;
            };

            this.handleScroll = debounce(async ({target}) => {
                const {scrollTop, offsetHeight, scrollHeight} = target;
                const select = this.getContainer(target).querySelector(targetSelectSelector);
                const percent = Math.ceil((scrollTop + offsetHeight) / scrollHeight * 100);
                const id = $dom.attr(select, 'id');

                if (!id) {
                    this.idWarn(select);
                    return;
                }

                const field = this.fields[id];
                const {loadDisabled, instance} = field;

                if (percent > 95 && !loadDisabled) {
                    const searchType = field.element.getAttribute(searchTargetAttr);

                    if (searchType && searchType !== searchTypes.addresses) {
                        const result = await this.makeRequest(searchType, id, () => {
                            this.updateField(id, {
                                page: field.page+=1
                            });
                        });

                        instance.setChoices(result, 'value', 'label', false);
                    }
                }
            }, variables.inputDebounce);

            this.handleSearch = debounce(async e => {
                const {detail} = e;
                const id = $dom.attr(e.target, 'id');

                if (!id) {
                    this.idWarn(e.target);
                    return;
                }

                const field = this.fields[id];

                this.updateField(id, {
                    page: 1,
                    searchQuery: detail.value
                });

                const searchType = field.element.getAttribute(searchTargetAttr);
                
                if (searchType) {
                    const result = await this.makeRequest(searchType, id);
                    this.updateField(id, {page: 2});

                    field.instance.setChoices(result, 'value', 'label', true);
                }
            }, variables.inputDebounce);

            this.resetItems = async id => {
                const field = this.fields[id];

                this.updateField(id, {
                    searchQuery: '',
                    page: 1
                });

                const searchType = field.element.getAttribute(searchTargetAttr);

                resetChoice(field.instance);

                if (searchType) {
                    const result = await this.makeRequest(searchType, id);
                    this.updateField(id, {page: 2});

                    field.instance.setChoices(result, 'value', 'label', true)
                }
            }

            this.handleSearchFieldInput = e => {
                const select = this.getContainer(e.target).querySelector(targetSelectSelector);
                const id = $dom.attr(select, 'id');
                if (e.target.value === '' && id) this.resetItems(id)
            };

            this.makeRequest = (searchType, id, onSuccess) => {
                let field = this.fields[id];
                if (!field) return;

                let params = {page: field.page}, requestMethod;
                const {api_search, select, api_personal} = $Page.components;
                
                if (searchType === searchTypes.addresses) {
                    let countryId = '', cityId = '';
                    const fieldParent = $dom.getParent(field.element, '[data-search-select-parent]');

                    const boundCountrySelect = document.getElementById(
                        field.element.getAttribute('data-bound-country-select-id')
                    );
                    const boundCitySelect = document.getElementById(
                        field.element.getAttribute('data-bound-city-select-id')
                    );

                    if (boundCountrySelect && boundCitySelect) {
                        countryId = getChoice(boundCountrySelect).getValue(true);
                        cityId = getChoice(boundCitySelect).getValue(true);
                    } else {
                        countryId = field.element.getAttribute('data-default-country-id') || '';
                        cityId = field.element.getAttribute('data-default-city-id') || '';
                    }                    
                    params = {
                        countryId, cityId,
                        query: field.searchQuery
                    };

                    $dom.addClass(fieldParent, variables.classNames.lazyLoading);
                    return (field.searchQuery && (countryId && cityId)) 
                        ? api_personal.searchAddress(params)
                            .then(results => {
                                return results
                                    .map(result => {
                                        const {fullAddress, shortAddress} = result;

                                        return {
                                            label: fullAddress, 
                                            value: shortAddress, 
                                            customProperties: result
                                        }
                                    });
                            })
                            .finally(() => $dom.removeClass(fieldParent, variables.classNames.lazyLoading))
                        : new Promise(resolve => {
                            $dom.removeClass(fieldParent, variables.classNames.lazyLoading);
                            resolve([]);
                        })
                }

                switch (searchType) {
                    case searchTypes.cities:
                        params = $data.merge(params, {
                            withR: true,
                            locale: getMeta(variables.metaNames.countryIso),
                            _type: 'query',
                        })

                        if (field) {
                            if (field.searchQuery) {
                                params = $data.merge(params, {
                                    term: field.searchQuery,
                                    _type: 'query:append'
                                })
                            }

                            if (is.not.undefined(field.alfa)) {
                                params = $data.merge(params, {
                                    alfa: field.alfa
                                })
                            }
                        }

                        requestMethod = api_search.getCities
                        break;
                    case searchTypes.subway:
                        const boundCitySelectId = field.element.getAttribute(boundSelectIdAttr);
                        const citySelectField = this.fields[boundCitySelectId];
                        const city_id = citySelectField.instance.getValue(true);

                        if (citySelectField && city_id) {
                            params = {...params, city_id};
                            requestMethod = api_search.getMetro
                        }
                        break;
                    case searchTypes.personalCities:
                        const boundCountrySelectId = field.element.getAttribute(boundSelectIdAttr);
                        const countrySelect = select.fields[boundCountrySelectId];
                        const cid = countrySelect.getValue(true);

                        if (countrySelect && cid) {
                            params = {...params,cid}
                            requestMethod = api_personal.searchCities
                        }

                        break;
                }

                if (field && field.searchQuery)
                    params = $data.merge(params, {
                        q: field.searchQuery
                    })

                if (Boolean(id)) this.updateField(id, {loadDisabled: true});

                if (
                    storage({
                        action: 'get',
                        params, searchType
                    })
                )
                    return new Promise(resolve => {
                        let data = storage({
                            action: 'get',
                            params, searchType
                        });

                        if (field.excludeAllCountryOption)
                            data = data
                                .filter(result => result.value !== 0 && result.value !== '');

                        resolve(data);
                        this.updateField(id, {loadDisabled: false});
                        is.function(onSuccess) && onSuccess(data);
                    })

                return requestMethod
                    ? requestMethod(params)
                        .then(data => {
                            let {results} = data;
                            if (results) {

                                results = results
                                    .map(result => {
                                        const {text, id} = result;
                                        return {label: text, value: id, customProperties: result}
                                    });


                                if (field.excludeAllCountryOption)
                                    results = results
                                        .filter(result => Boolean(result.value));

                                is.function(onSuccess) && onSuccess(data);

                                storage({
                                    action: 'set',
                                    params, results, searchType
                                });

                                return results
                            }

                            return []
                        })
                        .finally(() => this.updateField(id, {loadDisabled: false}))
                    : []
            };

            this.handleChoice = event => {
                const fieldId = event.target.getAttribute('id');
                if (this.fields.hasOwnProperty(fieldId))
                    this.resetItems(fieldId)
            }

            this.initChoice = target => {
                const id = $dom.attr(target,'id');
                
                if (id && !this.fields.hasOwnProperty(id)) {                    
                    const instance = new Choices(target, {
                        ...variables.choicesOptions,
                        resetScrollPosition: false,
                        shouldSort: false,
                        searchResultLimit: 25,
                        placeholder: true,
                        renderSelectedChoices: false,
                        noChoicesText: target.getAttribute('data-search-no-choices-text') || variables.choicesOptions.noChoicesText
                    });

                    const listElement = $dom.get(
                        `.${listDropdownClassName} .${listClassName}`,
                        this.getContainer(instance)
                    );

                    $events.add('scroll', listElement, this.handleScroll);

                    this.fields[id] = {
                        element: target,
                        instance,
                        loadDisabled: false,
                        searchQuery: '',
                        page: 1,
                        excludeAllCountryOption: target
                            .getAttribute(excludeAllCountryOptionAttr) === 'true'
                    }

                    return;
                }
            } 

            this.initChoices = () => {
                $dom.each(this.targets, target => {
                    this.initChoice(target)
                });
                return this;
            };

            this.setStartFieldChoiceList = async target => {
                const id = $dom.attr(target, 'id');
                const field = this.fields[id];
                const type = target.getAttribute(searchTargetAttr)

                if (field) {
                    const results = await this.makeRequest(type, id);
                    field.instance.setChoices(results, 'value', 'label', true);
                    this.updateField(id, {page: field.page+=1})
                }
            }

            this.initStartChoicesList = () => {
                $dom.getAll(`[${searchTargetAttr}]`)
                    .map(el => el.getAttribute(searchTargetAttr))
                    .filter((value, index, array) => (array.indexOf(value) === index) && value)
                    .forEach(async type => {
                        const targets = $dom.getAll(`[${searchTargetAttr}="${type}"]`);

                        if (Object.values(searchTypes).includes(type)) {
                            $dom.each(targets,  (target, index) => {
                                const updateFieldTimeout = setTimeout(async () => {
                                    this.setStartFieldChoiceList(target);
                                    clearTimeout(updateFieldTimeout)
                                }, variables.inputDebounce * (index+1))
                            })
                        }
                    })
                ;

                return this;
            }

            this
                .initChoices()
                .initStartChoicesList()
            ;

            $events
                .delegate
                .on('search', targetSelectSelector, this.handleSearch)
                .on('input', `.${listDropdownClassName} .${inputClassName}`, this.handleSearchFieldInput)
                .on('choice', window, this.handleChoice)
        },
        onDestroy() {
            Object.values(this.fields).forEach(({instance}) => {
                if(instance instanceof Choices) instance.destroy();
            })

            this.fields = {};

            $events
                .delegate
                .off('search', targetSelectSelector, this.handleSearch)
                .off('input', `.${listDropdownClassName} .${inputClassName}`, this.handleSearchFieldInput)
                .off('choice', window, this.handleChoice)
        }
    })
}
